import { render, staticRenderFns } from "./RecognizingDialog.vue?vue&type=template&id=c73ca820&scoped=true"
import script from "./RecognizingDialog.vue?vue&type=script&lang=js"
export * from "./RecognizingDialog.vue?vue&type=script&lang=js"
import style0 from "./RecognizingDialog.vue?vue&type=style&index=0&id=c73ca820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73ca820",
  null
  
)

export default component.exports